module.exports = __webpack_public_path__ + "static/media/mitsubishi.ce7aafee.png";